/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2024-04-28 19:31:18
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-04-30 14:27:43
 * @FilePath: /seller-station-client/src/common/layout/sidebarTool/Index.tsx
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import Editbianji from '@/common/icons/Editbianji';
import ToTopqudingbu from '@/common/icons/ToTopqudingbu';
import Customerservicekefu from '@/common/icons/Customerservicekefu';
import { useWindowSize } from '@/hooks/useWinSize';
import { useQuestionUpModal } from './QuestionUp/Index';

const SidebarTool = () => {
	const itemClass =
		'p-[14px] flex cursor-pointer justify-center items-center rounded-full border bg-black-0 text-black-950 border-grey-4  hover:bg-grey-3  mb-[16px]';
	const [QuestionUpModal, { open, close }] = useQuestionUpModal();
	const { width } = useWindowSize();
	return (
		<div
			className={classNames('fixed z-50 flex flex-col bottom-[160px]')}
			style={{
				left: `${width > 1200 ? (width - 1200) / 2 + 1220 : 1220}px`
			}}
		>
			<div className={classNames('custom-chat-button', itemClass)}>
				<Customerservicekefu className="text-h4" />
			</div>
			<div
				className={classNames(itemClass, 'relative')}
				onClick={() => open()}
				id="question"
			>
				<Editbianji className="text-h4" />
			</div>
			<div
				className={itemClass}
				onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
			>
				<ToTopqudingbu className="text-h4 " />
			</div>
			{QuestionUpModal}
		</div>
	);
};

export default SidebarTool;
